import { useSWRConfig } from 'swr';
import { deleteFetcher } from '@/api/fetchers';
import { useParams } from 'react-router-dom';
import { displayError } from '@/utils/error/errorHandler';

export default function useDeleteExceptionalEvent() {
  const { employeeId } = useParams<{ employeeId: string }>();
  const { mutate } = useSWRConfig();

  const deleteExceptionalEvent = async (id: number) => {
    try {
      if (employeeId === undefined)
        throw new Error('employeeId is undefined. Check URL.');

      await deleteFetcher(`/employees/${employeeId}/exceptional-events/${id}`);

      await mutate(`/employees/${employeeId}/exceptional-events`);
    } catch (err) {
      displayError(err);
    }
  };

  return {
    deleteExceptionalEvent,
  };
}
